export default "/etc.clientlibs/des/user-auth/clientlibs/des-user-auth/resources/7829abe590636200d15f97bd73880c31.png";